import PropTypes from "prop-types";

import BlogCategoryBtn from "@/components/actions/button/BlogCategoryBtn";
import { useScrollToRef } from "@/hooks";

export const BlogCategoryBar = ({ data, active, clickHandler }) => {
  const { ref: activeButtonRef } = useScrollToRef([active]);

  if (data?.length > 0) {
    return (
      <div className="bg-[#E8FAED7A] px-[1.25rem] lg:space-x-[4.875rem] lg:px-[7.5rem]">
        <div className="horizontal-scroll container flex flex-nowrap space-x-[1.688rem] overflow-x-auto lg:space-x-[5.625rem]">
          {data.map(({ slug, name }) => (
            <BlogCategoryBtn
              key={slug}
              btnText={name}
              isActive={slug === active}
              onClick={() => clickHandler(slug)}
              ref={active === slug ? activeButtonRef : null}
            />
          ))}
        </div>
      </div>
    );
  }

  return null;
};

BlogCategoryBar.propTypes = {
  active: PropTypes.string,
  clickHandler: PropTypes.func,
  data: PropTypes.arrayOf(
    PropTypes.shape({ slug: PropTypes.string, name: PropTypes.string })
  ).isRequired,
};
